module.exports = __webpack_public_path__ + "static/media/banner_small_ar.436896e6.png";